<template lang="pug">
modal(id="po-email", ref="modal", :loading="onLoading('mail-purchase-order')")
    template(slot="title") Email Purchase Order
    template(slot="footer")
        button.md-btn.md-raised.m-b-sm.w-xs.green(@click="submit", :disabled="onLoading('mail-purchase-order')")
            v-loading(loader="mail-purchase-order") Send
    template(slot="body")
        form(id="po-send-mail", @submit.prevent="")
            fieldset(:disabled="onLoading('mail-purchase-order')")
                div.form-group
                    label To
                    multiselect(
                        v-model="address",
                        :options="addressList",
                        placeholder="Type to add email",
                        tag-placeholder="Enter to add email address",
                        :multiple="true",
                        :taggable="true",
                        @tag="addAddress"
                    )
                    span.text-danger(v-if="errors.has('address')")
                        | {{ errors.first('address') }}

                div.form-group
                    label Cc
                    multiselect(
                        v-model="cc",
                        :options="ccList",
                        placeholder="Type to add email",
                        tag-placeholder="Enter to add email address",
                        :multiple="true",
                        :taggable="true",
                        @tag="addCc"
                    )
                    span.text-danger(v-if="errors.has('cc')")
                        | {{ errors.first('cc') }}

                div.form-group
                    label Subject
                    input.form-control(
                        :class="{ 'has-error': errors.has('subject') }",
                        key="subject",
                        name="subject",
                        v-validate="'required'",
                        type="text",
                        v-model="subject"
                    )
                    span.text-danger(v-if="errors.has('subject')")
                        | {{ errors.first('subject') }}


                div.form-group
                    label Message
                    textarea.form-control(
                        rows="5",
                        v-model="message"
                    )                    
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    data() {
        return {
            address: [],
            cc: [],
            subject: null,
            message: null,
            addressList: [],
            ccList: [],
        };
    },

    computed: {
        canSubmit() {
            return (
                this.address.length > 0 &&
                this.subject !== null &&
                this.subject.trim() !== ''
            );
        },

        ...mapGetters('purchaseOrder', ['purchaseOrder', 'supplier']),
    },

    watch: {
        'purchaseOrder.id'(id) {
            if (id !== null) {
                this.subject = `Purchase Order ${this.purchaseOrder.order_no}`;
                this.cc = [];
                this.address =
                    this.supplier.contact_email !== null
                        ? [this.supplier.contact_email]
                        : [];

                this.errors.clear();
            }
        },
    },

    mounted() {
        this.$on('show', () => {
            this.$refs.modal.$emit('show');
        });
    },

    methods: {
        addAddress(address) {
            this.address.push(address);
        },

        addCc(address) {
            this.cc.push(address);
        },

        ...mapActions('purchaseOrder', ['sendMail']),

        async submit() {
            const options = {
                subject: this.subject,
                address: this.address,
                cc: this.cc,
                message: this.message,
            };

            try {
                const { data } = await this.sendMail(options);
                this.$refs.modal.$emit('hide');
                this.swal({ title: 'Email has successfully sent!' });
            } catch (e) {
                if (this.hasLaravelErrors(e)) {
                    this.processLaravelErrors(
                        this.$validator,
                        e.response,
                        false,
                        'first',
                    );
                } else {
                    this.swalError({ text: e });
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/purchase-order/purchase-order-email.vue